import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  careers: [],
  careerResults: [],
  programResults: [],
  currentFacet: 'all',
  bookmarks: [],
  programGuideFacetResults: [],
  programGuideSearchResults: [],
  programGuideSearchTerms: '',
  programGuideSearchSort: {},
  programGuideSearchFilter: {},
  programGuideSearchSelectedFacetNames: [],
  programGuideSearchCustomIncomeMin: '',
  programGuideSearchCustomIncomeMax: '',
  careerFacetResults: [],
  careerSearchResults: [],
  careerSearchTerms: '',
  careerSearchSort: {},
  careerSearchFilter: {},
  careerSearchSelectedFacetNames: [],
  careerSearchCustomIncomeMin: '',
  careerSearchCustomIncomeMax: '',
  programTotal: 0,
  careerTotal: 0,
  institutionCareers: [],
  careerSearchInstitutionCareerFilter: true
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/explore/vuex/index.js